module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Chapter 2")])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('h2', {
    staticClass: "h2sub"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Intervals")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("The most elemental part of music theory is to understand the relationships between single notes. The distance between those notes is an interval, which will serve as the foundation for practically every concept that you will explore throughout this book. Understanding intervals is extremely important.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 90
// module chunks = 0